import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from '../global.service';
import { ManualUploadProcStatusService } from './manual-upload-proc-status.service';
import { ManualUploadProcStatusEditDialogComponent, UploadProcEditData } from './manual-upload-proc-status-edit-dialog.component';

@Component({
  selector: 'app-manual-upload-proc-status',
  templateUrl: './manual-upload-proc-status.component.html',
  styleUrls: ['./manual-upload-proc-status.component.css'],
  standalone: false
})
export class ManualUploadProcStatusComponent implements OnInit {

  // The 6 proc_nm values owned by the manual upload screen
  readonly UPLOAD_PROC_NAMES = [
    { proc_nm: 'PART_MASTER_UPLOAD',      label: 'Part Master' },
    { proc_nm: 'PC_VEH_SPEC_INDEX_UPLOAD', label: 'eBoM SVI Upload' },
    { proc_nm: 'PC_SPEC_UPLOAD',           label: 'PC Spec Upload' },
    { proc_nm: 'PROD_PART_CONTENT_UPLOAD', label: 'Prod Part Content' },
    { proc_nm: 'PROD_PART_STRUC_UPLOAD',   label: 'Prod Part Struc' },
    { proc_nm: 'ZPF_UPLOAD',               label: 'ZPF Upload' },
  ];

  readonly STATUS_OPTIONS = ['STARTED', 'INITIATED', 'IN_PROGRESS', 'COMPLETED', 'ERROR'];

  errorMessage = '';
  successMessage = '';
  spinnerMessage = 'Please Wait...';

  filterProcNm: string | null = null;
  filterProcSts: string | null = null;

  rows: any[] = [];
  selected: any[] = [];
  showdata = true;
  sameLengthRows = false;
  limitSelected = 50;
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  @ViewChild('myTable') table: any;

  step = 0;
  roleAccess: any[] = [];
  Roledata: any = [];
  accessEnable = true;

  constructor(
    private spinnerService: NgxSpinnerService,
    private service: ManualUploadProcStatusService,
    private dialog: MatDialog,
    public globalrole: GlobalService
  ) {}

  ngOnInit(): void {
    (async () => {
      this.spinnerService.show();
      await this.userroleAccessfn();
      if (this.accessEnable) { this.loadGrid('initial'); }
    })();
  }

  setStep(i: number) { this.step = i; }

  procLabel(procNm: string): string {
    const match = this.UPLOAD_PROC_NAMES.find(u => u.proc_nm === procNm);
    return match ? match.label : procNm;
  }

  loadGrid(option: string): void {
    this.selected = [];
    this.spinnerService.show();
    this.service.getUploadProcStatusList(this.filterProcNm, this.filterProcSts).subscribe(data => {
      this.spinnerService.hide();
      this.showdata = true;
      this.rows = (data.payload || []).map((row: any) => ({
        upload_id:    row.upload_id,
        proc_nm:      row.upload_type,
        proc_label:   this.procLabel(row.upload_type),
        proc_status:  row.upload_status,
        email_id:     row.email_id,
        rmrk_txt:     row.remarks,
        update_by_id: row.update_by_id,
        create_by_id: row.create_by_id,
        update_ts:    row.update_ts ? row.update_ts.replace('Z', '').replace('T', ' ') : '',
        create_ts:    row.create_ts ? row.create_ts.replace('Z', '').replace('T', ' ') : '',
      }));
    }, err => {
      this.spinnerService.hide();
      this.showdata = false;
      this.rows = [];
      this.errorMessage = err === 0 ? 'Request timed out. Please try again.' : 'No Records';
      this.globalrole.goToTop();
    });
  }

  search(): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.loadGrid('initial');
  }

  reset(): void {
    this.filterProcNm = null;
    this.filterProcSts = null;
    this.selected = [];
    this.errorMessage = '';
    this.successMessage = '';
    this.loadGrid('initial');
  }

  onSelect({ selected }: any): void {
    this.selected = [...selected];
    this.sameLengthRows = selected.length > 0;
  }

  displayCheck(row: any) { return row; }
  singleSelectCheck(row: any) { return this.selected.indexOf(row) === -1; }

  openEditDialog(): void {
    this.errorMessage = '';
    this.successMessage = '';
    if (this.selected.length === 0) {
      this.errorMessage = 'Please select a row to edit.';
      this.globalrole.goToTop();
      return;
    }
    if (this.selected.length > 1) {
      this.errorMessage = 'Please select only one row to edit.';
      this.globalrole.goToTop();
      return;
    }
    if (!this.roleAccess.includes('Update')) {
      this.errorMessage = "User does not have permission to perform 'update' operation";
      this.globalrole.goToTop();
      return;
    }
    const row = this.selected[0];
    const dialogData: UploadProcEditData = {
      upload_id:     row.upload_id,
      upload_type:   row.proc_nm,
      upload_status: row.proc_status,
      remarks:       row.rmrk_txt || ''
    };
    const ref = this.dialog.open(ManualUploadProcStatusEditDialogComponent, { disableClose: true, data: dialogData, width: '420px' });
    ref.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.successMessage = 'Record updated successfully.';
        this.selected = [];
        this.loadGrid('add');
      }
    });
  }

  closeAlert(): void { this.errorMessage = ''; this.successMessage = ''; }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      'COMPLETED':   'status-completed',
      'STARTED':     'status-started',
      'INITIATED':   'status-initiated',
      'IN_PROGRESS': 'status-inprogress',
      'ERROR':       'status-error',
    };
    return map[status] || '';
  }

  userroleAccessfn() {
    return new Promise(resolve => {
      this.globalrole.Roledetails.subscribe(res => {
        this.Roledata = res;
      })
      if (this.Roledata.length != 0) {
        this.Roledata.filter((res: any) => {
          if (res.function_nm == 'NBPC_10117') {
            this.roleAccess.push(res.access_desc);
          }
        })
        if (this.roleAccess.length > 0) {
          this.accessEnable = true;
          resolve(true)
        } else {
          this.roleAccess = [];
          this.errorMessage = "User does not have permission to perform 'read' operation";
          this.accessEnable = false;
          this.spinnerService.hide();
          resolve(false)
        }
      } else if (this.Roledata.length == 0) {
        let arrayvalue: any; let roleList: any;
        let data = localStorage.getItem('role');
        arrayvalue = (data || '').split(',')
        let str = '';
        for (let i = 0; i < arrayvalue.length; i++) {
          if (str == '') {
            str = "'" + arrayvalue[i] + "'"
          } else {
            str += ',' + "'" + arrayvalue[i] + "'";
          }
          roleList = str;
        }
        let body = {
          security_grp_nm: roleList
        }
        let userpreviliagedata = localStorage.getItem('userpreviliagedata')
        if (userpreviliagedata && userpreviliagedata.length != 0 && userpreviliagedata != "") {
          this.globalrole.changeMessage(JSON.parse(userpreviliagedata))
          this.globalrole.Roledetails.subscribe(res => { this.Roledata = res; })
          this.Roledata.filter((res: any) => {
            if (res.function_nm == 'NBPC_10117') {
              this.roleAccess.push(res.access_desc);
            }
          })
          if (this.roleAccess.length > 0) {
            this.accessEnable = true;
            resolve(true)
          } else {
            this.roleAccess = [];
            this.errorMessage = "User does not have permission to perform 'read' operation";
            this.accessEnable = false;
            this.spinnerService.hide();
            resolve(false)
          }
        } else {
          this.roleAccess = [];
          this.errorMessage = "User does not have permission to perform 'read' operation";
          this.accessEnable = false;
          this.spinnerService.hide();
        }
      }
    })
  }
}
